import { Routes, Route, Navigate } from "react-router-dom";

import Login from "pages/Login";
import Layout from "layout";
import { useSelector } from "react-redux";
import React from "react";
import TestText from "pages/TestText";
import TestForm from "pages/TestForm/TestForm";
import TestWijmo from "pages/TestWijmo/TestWijmo";
import Loading from "components/Loading";
import UnderConstruction from "components/UnderConstruction";
import BringValueInGrid from "pages/BringValueInGrid";
import Dashboard from "pages/Dashboard";
import {
  menuKeyDashboard,
  menuKeyLogsExpl,
  menuKeyOrdersExpl,
  menuKeyOrderView,
} from "api/MenuKeys";
import LogsExplorer from "pages/LogsExpl";
import OrdersExplorer from "pages/OrdersExpl";
import OrderView from "pages/OrderView";

// import useRoutingAccess from "./useRoutingAccess";
// import Loadable from "./Components/Loadable";

const AppRouter = () => {
  const isLoggedIn = useSelector((storeState) => storeState?.auth?.isLoggedIn);

  // const { withPermission } = useRoutingAccess();

  // const EpgeBudgetIsoz = withPermission(
  //   Loadable(lazy(() => import("pages/EpgeBudgetIsoz"))),
  //   { menuKey: menuKeyEpgeBudgetIsoz }
  // );

  if (isLoggedIn) {
    return (
      <Layout>
        <Loading />
        <Routes>
          <Route path="/login" element={<Navigate to={menuKeyLogsExpl} />} />
          <Route path="/testText" element={<TestText />} />
          <Route path="/testWijmo" element={<TestWijmo />} />
          <Route path="/search" element={<TestWijmo />} />
          <Route path="/bvGrid" element={<BringValueInGrid />} />
          <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path={menuKeyLogsExpl} element={<LogsExplorer />} />
          <Route path={menuKeyOrdersExpl} element={<OrdersExplorer />} />
          <Route path="/order-view/:id" element={<OrderView />} />
          <Route path={menuKeyDashboard} element={<Dashboard />} />
          <Route path="/bvTest" element={<TestForm />} />
          <Route path="*" element={<Navigate to={"/under-construction"} />} />
        </Routes>
      </Layout>
    );
  } else
    return (
      <Layout>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to={"/login"} />} />
        </Routes>
      </Layout>
    );
};

export default AppRouter;
